import { SESSION_KEY_CHAT_HISTORY, SESSION_KEY_CHAT_OPEN_STATE, SESSION_KEY_ID } from './constants';

export function clearChatBotSessionData() {
    window.sessionStorage.removeItem(SESSION_KEY_ID);
    window.sessionStorage.removeItem(SESSION_KEY_CHAT_OPEN_STATE);
    window.sessionStorage.removeItem(SESSION_KEY_CHAT_HISTORY);
}
